import Alpine from 'alpinejs';

export default function initTabs() {
  Alpine.data('tabs', () => ({
    isExpanded: false,
    selectedTab: '',
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    initTabs(selectedTab: string) {
      this.selectedTab = selectedTab;
    },
    toggleTab(tab: string) {
      this.selectedTab = tab;
      const mobileLink = this.$el
        .closest('.information-tabs')
        ?.querySelector('.mobile-main-link .title');
      if (mobileLink) {
        mobileLink.innerHTML = this.$el.innerHTML;
      }
      this.isExpanded = false;
    },
    showTab(tab: string) {
      return this.selectedTab === tab;
    },
  }));
}
